import { icons } from 'src/assets/iconDef/icon.def';

export const biReportsMenuDef = [
    {
        resource: "etl_template",
        url: "etl_template",
        auto_crud: true,
        "route_def": {
        "dynamic": "/:foreign_id",
            "data": {
                "foreign_id": "template_type",
                "add_foreign": true
            }
        }
    },
    {
        resource:"manage_account_dbconn",
        url:"manage_account_dbconn",
        auto_crud: true
    },
    {
        resource: "etl_job_exec",
        url: "etl_job_exec",
        auto_crud: true,
        "route_def": {
        "dynamic": "/:foreign_id",
            "data": {
                "foreign_id": "template_code",
                "add_foreign": true
            }
        }
    },
]
